<template>
  <el-table
      border
      :header-cell-style="{
      background: '#FFEDDD',
      height: '48px',
      color: 'rgba(0, 0, 0, 0.80)'
      }"
      ref="table"
      :show-summary="showSummary"
      :summary-method="summaryMethod"
      :row-class-name="rowClassName"
      v-bind="tableConfig.tableSettings"
      :data="tableConfig.data"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
      :default-sort="defaultSort"
  >
    <el-table-column
        v-if="tableConfig.hasSelection"
        type="selection"
        width="55"
    ></el-table-column>

    <el-table-column
        v-for="item in tableConfig.columnsSettings"
        :key="item.prop"
        v-bind="item"
    >
      <template #header="scope">
        <template v-if="item.headerSlot">
          <slot :name="item.headerSlot"></slot>
        </template>
        <template v-else>
          {{ item.label }}
        </template>
      </template>

      <template #default="{row}">
        <template v-if="item.type === 'slot'">
          <slot :name="item.prop" :row="row"></slot>
        </template>
        <template v-else-if="['select', 'radio'].includes(item.type)">
          {{ getEnumValueByKey(item.options, row[item.prop]) }}
        </template>
        <template v-else-if="item.type === 'imageList'">
          <el-image
              class="width-100 m-r-5"
              v-for="(it, index) in row[item.prop]"
              :key="index"
              :z-index="index"
              :src="it"
              fit="cover"
              :preview-src-list="row[item.prop]"
          ></el-image>
        </template>
        <template v-else>
          {{ row[item.prop] }}
        </template>
      </template>
    </el-table-column>

    <el-table-column
        fixed="right"
        v-if="tableConfig.hasAction"
        label="操作"
        :width="tableConfig.actionWidth || '120'"
    >
      <template #default="{row}">
        <slot name="action" :row="row"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { getEnumValueByKey } from "@/utils";

const emit = defineEmits(['selectionChange', 'sortChange']);

const props = defineProps({
  summaryData: {
    type: Object,
  },
  defaultSort: {
    type: Object,
    default: () => ({})
  },
  showSummary: {
    type: Boolean,
    default: false
  },
  rowClassName: {
    type: Function,
    default: () => '' // 默认返回空字符串
  },
  tableConfig: {
    required: true,
    type: Object,
    default: () => ({
      hasSelection: false,
      tableSettings: {},
      columnsSettings: [],
      data: [],
      hasAction: false,
      actionWidth: '120'
    })
  }
});

const handleSelectionChange = (val) => {
  emit('selectionChange', val);
};

const handleSortChange = (val) => {
  emit('sortChange', val);
};

const summaryMethod = () => {
  const sums = [];
  props.tableConfig.columnsSettings.forEach((item, index) => {
    sums[index] = '合计';
    if (index === 0) {
      sums[index] = '合计';
    } else if (item.isSum) {
      sums[index] = item.type === 'rate'
          ? props.summaryData[item.prop] + '%'
          : props.summaryData[item.prop];
    } else {
      sums[index] = '-';
    }
  });
  return sums;
};
</script>

<style scoped lang="less">
.width-100 {
  width: 100%;
}
.mr-5 {
  margin-right: 5px;
}
</style>